<template>
  <ul class="p-0 m-0 list-none">
    <slot />
  </ul>
</template>

<script setup>
const nuxtApp = useNuxtApp();

const Accordion = reactive({
  count: 0,
  active: [],
});

nuxtApp.provide("Accordion", Accordion);
</script>

<style scoped></style>
